import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getLearningPathLessons } from "../../../api/endpoints/LearningPathEndpoints";
import { Lesson } from "../../../models/Lesson";
import { Paged } from "../../../models/Paged";

export default function useGetLearningPathLessons(learningPathId: string) {
  return useMutation<Paged<Lesson>, AxiosError, { page: number }>({
    mutationKey: ["learning-path-lessons", learningPathId],
    mutationFn: ({ page }) => getLearningPathLessons(learningPathId, page),
  });
}
